import styled from 'styled-components';

const Horizon = styled.hr`
  border: ${({ thickness }) => thickness || 0.1}px solid
    ${({ color }) => color || '#000000'};
  opacity: 0.1;
`;

export default Horizon;
